<agpr-dialog-container
    [id]="id"
    class="agpr-precisionClip"
    [heading]="loading ? (isPreview ? 'Monitor.precisionClip.loading.preview.header' : 'Monitor.precisionClip.loading.header') : 'Monitor.precisionClip.setup.header'"
    [headingIcon]="loading ? null : 'fa-kit-duotone fa-agpr-ai-generic'"
    [modal]="true"
    [showLoadingHeader]="loading"
    (close)="closeDialog()"
>
    <div
        class="agpr-precisionClip-content"
        [class.justify-center]="loading"
    >
        @if (loading) {
            <div class="agpr-precisionClip-contentLoading">
                <span> {{ 'Monitor.precisionClip.loading.message' | localize }} </span>
                <span class="agpr-precisionClip-contentLoading-text">
                    {{ currentLoadingMessage | localize }}
                </span>
            </div>
        } @else {
            <div>
                <h6 class="agpr-headerH3-dark">
                    {{ 'Monitor.precisionClip.setup.keyword.heading' | localize }}
                </h6>

                <div
                    class="agpr-precisionClip-group"
                    role="radiogroup"
                    [attr.aria-label]="'Monitor.precisionClip.setup.keyword.heading' | localize"
                >
                    <div class="agpr-precisionClip-group">
                        <agpr-radio
                            [id]="id + '_savedMentionKeywordOption'"
                            [value]="keywordSelectionEnum.SAVED_MENTION"
                            [disabled]="mentionKeywords.length === 0"
                            label="Monitor.precisionClip.setup.keyword.option.mention"
                            hiddenLabel="Monitor.precisionClip.setup.keyword.option.mention"
                            [(ngModel)]="keywordSelection"
                        ></agpr-radio>

                        @if (keywordSelection === keywordSelectionEnum.SAVED_MENTION) {
                            <div class="agpr-precisionClip-keyword-input">
                                @for (keyword of mentionKeywords; track keyword) {
                                    <span class="agpr-precisionClip-keyword-highlight">
                                        {{ keyword }}
                                    </span>
                                }
                            </div>
                        }
                    </div>
                    <div class="agpr-precisionClip-keyword">
                        <agpr-radio
                            [id]="id + '_manualKeywordOption'"
                            [value]="keywordSelectionEnum.MANUAL"
                            label="Monitor.precisionClip.setup.keyword.option.manual"
                            hiddenLabel="Monitor.precisionClip.setup.keyword.option.manual"
                            [(ngModel)]="keywordSelection"
                        ></agpr-radio>

                        @if (keywordSelection === keywordSelectionEnum.MANUAL) {
                            <agpr-text-input-chips
                                [id]="id + '_manualKeywords'"
                                class="agpr-precisionClip-keyword-input"
                                placeholder="Mention.workbench.insights.prompt.enterKeywords"
                                [(ngModel)]="manualKeywords"
                            ></agpr-text-input-chips>
                        }
                    </div>
                </div>
            </div>

            <div>
                <h6 class="agpr-headerH3-dark">
                    {{ 'Monitor.precisionClip.setup.insights' | localize }}
                </h6>

                <agpr-checkbox
                    [id]="id + '_insightsCheckbox'"
                    label="Monitor.precisionClip.setup.insights.label"
                    [binary]="true"
                    [(ngModel)]="insightsEnabled"
                ></agpr-checkbox>
            </div>
            <div class="agpr-precisionClip-group">
                <agpr-panel
                    [id]="id + '_expertPanel'"
                    class="agpr-precisionClip-panel"
                    header="Monitor.precisionClip.setup.expertSettings"
                    [collapsed]="true"
                    [showCustomHeader]="false"
                    [noBorder]="true"
                >
                    <div class="agpr-precisionClip-panelRow">
                        <agpr-number-input
                            [id]="id + '_extendStartTime'"
                            label='Monitor.precisionClip.setup.extend.start'
                            [(ngModel)]="extendStartTime"
                            [min]="0"
                            [max]="60"
                        ></agpr-number-input>

                        <agpr-number-input
                            [id]="id + '_extendEndTime'"
                            label='Monitor.precisionClip.setup.extend.end'
                            [(ngModel)]="extendedEndTime"
                            [min]="0"
                            [max]="60"
                        ></agpr-number-input>
                    </div>
                </agpr-panel>

                <agpr-message
                    [severity]="messageSeverityEnum.warning"
                >
                    {{ 'Monitor.precisionClip.setup.warning' | localize }}
                </agpr-message>
            </div>
        }
    </div>

    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '_cancelButton'"
            label="Core.button.cancel"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>

    @if (!loading) {
        <ng-template #footerRight>
            <agpr-button
                [id]="id + '_PreviewButton'"
                label="Monitor.precisionClip.setup.preview"
                [style]="buttonType.primary"
                [disabled]="keywordSelection === keywordSelectionEnum.MANUAL && manualKeywords.length === 0"
                (click)="preview()"
            ></agpr-button>

            <agpr-button
                [id]="id + '_PrecisionClipButton'"
                label="Monitor.precisionClip.setup.precisionClip"
                [style]="buttonType.primary"
                [disabled]="keywordSelection === keywordSelectionEnum.MANUAL && manualKeywords.length === 0"
                (click)="confirm()"
            ></agpr-button>
        </ng-template>
    }
</agpr-dialog-container>
